import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button,
  CardTitle,
  Spinner,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import {
  convertToLowestUnit,
  ExportAvailableInCSVForReports,
  formatUnitsForReport,
  MapObjectUnits,
} from "../../../../helpers/units";

import printDiv from "../../../../helpers/print_data";

const BranchwiseItemOrderReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [selectedBranchName, setSelectedBranchName] = useState("All");
  const [allBranches, setAllBranches] = useState([]);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
    loadAllBranches();
  }, []);

  // useEffect(() => {
  //   if (dateFrom && dateTo) {
  //     loadOrders();
  //   }
  // }, [dateFrom, dateTo, selectedBranch]);

  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const branches = response.data.filter(
        (store) =>
          store.type === "Branch" || store.type === "CENTRAL KITCHEN STORE",
      );
      setAllBranches(branches);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allOrders, setAllOrders] = useState([]);
  const decorateRows = (rows) =>
    (rows || []).map((row) => {
      const totalOrder = row.total_order || [];
      const totalDeliver = row.total_deliver || [];
      const totalReceiveQty = row.total_receive || [];
      const totalOrdered = convertToLowestUnit(row.unit_levels, totalOrder);
      const totalDispatched = convertToLowestUnit(
        row.unit_levels,
        totalDeliver,
      );
      const totalReceive = convertToLowestUnit(
        row.unit_levels,
        totalReceiveQty,
      );
      let row_bg = "";
      if (
        totalDispatched < totalOrdered &&
        (totalDeliver.length > 0 || totalReceiveQty.length > 0)
      ) {
        row_bg = "#87CEFA";
      } else if (
        totalReceive < totalDispatched &&
        (totalDeliver.length > 0 || totalReceiveQty.length > 0)
      ) {
        row_bg = "#b8f3ff";
      }
      return {
        ...row,
        row_key: row._id && row._id.item_id,
        row_bg,
      };
    });

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");

      if (daysDiff > 31) {
        setFilteredOrders([]);
        setAllOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setFilteredOrders([]);
        setAllOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setFilteredOrders([]);
      const url =
        process.env.REACT_APP_BASEURL +
        "itemorders/branchwise_item_order_report";
      const response = await postSubmitForm(url, {
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
        branch_id: selectedBranch,
      });
      if (requestId !== ordersRequestId.current) return;

      if (response && response.status === 1) {
        const result = decorateRows(response.data || []);
        if (result.length <= 0) {
          setAllOrders([]);
          showNotification("No Orders data found", "error");
        } else {
          setAllOrders(result);
          setTablePage(1);
        }
      } else {
        setAllOrders([]);
        showNotification((response && response.message) || "Error", "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      console.log(error);
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const [filteredOrders, setFilteredOrders] = useState([]);
  function afterFilter(newResult, newFilters) {
    setFilteredOrders(newResult);
  }

  const columns_external = [
    {
      dataField: "row_number",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return (tablePage - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Item"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allOrders.map(({ name: value }) => ({
                    value: value,
                    label: value,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];

          //console.log(unique);
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allOrders.map(({ category: value }) => ({
                    value: value,
                    label: value,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];

          //console.log(unique);
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    {
      dataField: "sub_category",
      text: props.t("Sub Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allOrders.map(({ sub_category: value }) => ({
                    value: value,
                    label: value,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];

          //console.log(unique);
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    // {
    //   dataField: "brand",
    //   text: props.t("Brand"),
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "18%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               allOrders.map(({ brand: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       //console.log(unique);
    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },

    {
      dataField: "total_order",
      text: props.t("Total Order"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.total_order);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "total_deliver",
      text: props.t("Total Delivered"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.total_deliver);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "total_receive",
      text: props.t("Total Received"),
      sort: true,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.total_receive);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const handleDownload = () => {
    const fileName = "BranchwiseItemOrderReport";
    const exportType = "xls";
    //console.log(selectedBranchName);

    if (filteredOrders) {
      var data = [];
      filteredOrders.forEach(function (v) {
        data.push({
          Name: v.name,
          Category: v.category,
          "Sub-Category": v.sub_category,
          "Total Order": ExportAvailableInCSVForReports(v.total_order),
          "Total Deliver": ExportAvailableInCSVForReports(v.total_deliver),
          "Total Receive": ExportAvailableInCSVForReports(v.total_receive),
          Branch: selectedBranchName,
        });
      });
      exportFromJSON({ data, fileName, exportType });
    }
  };

  const rowStyle = (row, rowIndex) => {
    return { backgroundColor: row.row_bg || "", fontWeight: "500" };
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Branch-wise Item Order Report")}
            title={props.t("Reports")}
            breadcrumbItem1={props.t("Orders")}
            breadcrumbItem2={props.t("Branch-wise Item Order Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="branch"
                          label={props.t("Branch")}
                          type="select"
                          value={selectedBranch}
                          onChange={(e) => {
                            setSelectedBranch(e.target.value);

                            setSelectedBranchName(
                              e.target.options[e.target.selectedIndex].text,
                            );
                          }}
                        >
                          <option value="All">{props.t("All")}</option>
                          {allBranches &&
                            allBranches.map((branch) => {
                              return (
                                <option key={branch._id} value={branch._id}>
                                  {branch.name}
                                </option>
                              );
                            })}
                        </AvField>
                      </Col>
                      <Col lg={3}>
                        {" "}
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>{" "}
                      {"    "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                    <Col sm="8">
                      <div className="status-legend d-flex align-items-center justify-content-end">
                        <div className="d-flex align-items-center mr-4">
                          <div
                            className="status-indicator"
                            style={{
                              backgroundColor: "#87CEFA",
                              width: "15px",
                              height: "15px",
                              borderRadius: "4px",
                              marginRight: "8px",
                            }}
                          />
                          <span>Partial Dispatch</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <div
                            className="status-indicator"
                            style={{
                              backgroundColor: "#b8f3ff",
                              width: "15px",
                              height: "15px",
                              borderRadius: "4px",
                              marginRight: "8px",
                            }}
                          />
                          <span>Partial Receive</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="row" id="printDiv">
                    <div className="col-md-12">
                      <CardTitle className="text-center">
                        {props.t("Branchwise Item Order Report")}{" "}
                      </CardTitle>
                      <ToolkitProvider
                        keyField="row_key"
                        data={allOrders && allOrders}
                        columns={columns_external}
                        bootstrap4
                        search
                      >
                        {(toolkitProps) => (
                          <div>
                            <Row>
                              <Col lg={4}>
                                <SearchBar
                                  {...toolkitProps.searchProps}
                                  style={{ width: "300px" }}
                                />
                              </Col>
                              <Col lg={4}></Col>
                              <Col lg={4} className="text-right"></Col>
                            </Row>
                            <BootstrapTable
                              striped
                              hover
                              condensed
                              rowStyle={rowStyle}
                              pagination={paginationFactory(pagination_options)}
                              filter={filterFactory({ afterFilter })}
                              noDataIndication={
                                isLoadingOrders ? (
                                  <Spinner size="md" />
                                ) : (
                                  props.t("No data to display.")
                                )
                              }
                              {...toolkitProps.baseProps}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(BranchwiseItemOrderReport)),
);
